import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

// Import your page components here
import PrivacyPolicy from "./components/Privacy-Policy";
import Disclaimer from "./components/Disclaimer";
import Sentinel from "./components/Sentinel";
import Norway from "./components/Norway";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Sentinel />} />
          <Route path="/sentinel" element={<Sentinel />} />

          <Route path="/norway" element={<Norway />} />

          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
